import lazyLoading from './lazyLoading.js'

export default {
  name: 'Locations',
  meta: {
    title: 'Locations',
    iconClass: 'fa fa-tablet',
    requiresAuth: true,
    policy: 'BusinessObject',
    access: 'read'
  },
  path: '/locations',
  component: lazyLoading('locations/Locations')
}



// WEBPACK FOOTER //
// ./src/store/modules/menu/locations.js